import { hideProp } from "../../tools/hideProp";
import { cloneDeep, set } from "lodash-es";
import Vue from 'vue';
import { getRealResponseSchema } from "../common/schemaUtil";
import { $methodKey } from "../stateJS/utils/consts";
import { customApiPrefix } from "../templates/apis/custom";
import { requestParamSchema, requestResultSchema } from "./param/requestParamSchema";
import { createAction } from "./utils/Action";
import { setStateSchema } from "./utils/setStateSchema";
import { getStateMeta } from "./utils/StateMeta";
export function initStateMeta() {
  const ctor = Object.getPrototypeOf(this).constructor;
  const ctorMeta = getStateMeta(ctor);
  Object.assign(this.stateMeta.actionInfos, ctorMeta.actionInfos); // 合并 custom 和 模板 action
  Object.assign(this.stateMeta.stateSchemas, ctorMeta.stateSchemas);
}
export function initRuntimeActions() {
  const {
    actionSchema
  } = this;
  const actions = actionSchema.fields;
  if (!actions || actions.length <= 0) {
    return;
  }
  actions.forEach(action => {
    hideProp(this, `$${action.id}`, {
      value: function stateAction(...args) {
        // 暂时不支持参数
        return this.dispatch(action.id, ...args);
      }
    });
  });
}
export function initCustomActions() {
  const {
    cgiInfo
  } = this.collection.collectionData;
  Object.entries(cgiInfo).forEach(([name, cgiInfo]) => {
    if (!name.startsWith(customApiPrefix)) {
      return;
    }
    hideProp(this, name, {
      async value(params) {
        // 自定义接口
        // 如果用户有传params 就透传 raw=true
        // 没有只能走动参
        const res = await this.collection[name](params || {
          query: {},
          body: {}
        }, {
          raw: !!params
        });
        Vue.set(this.customState, name, res.body);
        return {
          success: true,
          data: res.body
        };
      },
      configurable: true
    });
    const paramsSchema = this.getCgiParamSchema(name);
    registerAction.call(this, {
      actionName: name,
      methodName: name,
      def: {
        cgiDeps: [name],
        schema: {
          id: name,
          title: name + (cgiInfo.name ? `(${cgiInfo.name})` : ''),
          actionArguments: [{
            ...paramsSchema,
            ...requestParamSchema
          }],
          actionReturnValue: requestResultSchema
        }
      }
    });
  });
}
function registerAction(actionInfo) {
  this.stateMeta.registerAction(actionInfo);
  createAction(this, actionInfo);
}
/**
 * 初始化数据源的stateSchema，走异步更新，不阻塞同步初始化
 */
export async function initSchema() {
  hideProp(this, 'stateSchema', {
    value: {
      type: 'object',
      fields: []
    }
  });
  if (this.isJSStateModel) {
    var _this$stateSchema$fie;
    const methods = {
      id: $methodKey,
      hidden: true,
      title: '方法',
      type: 'object',
      methods: []
    };
    set(methods, 'uc:hiddenInDSTree', true);
    (_this$stateSchema$fie = this.stateSchema.fields) === null || _this$stateSchema$fie === void 0 || _this$stateSchema$fie.unshift(methods);
  }
  if (this.sync) {
    await this.promiseForCollection;
  }
  // 这里需要有先后顺序
  initCustomStateSchemas.apply(this);
  init$RequestsSchema.apply(this);
  setStateSchema.apply(this);
  if (this.sync) {
    var _this$options$sourceC, _this$options$sourceC2;
    (_this$options$sourceC = this.options.sourceController) === null || _this$options$sourceC === void 0 || (_this$options$sourceC2 = _this$options$sourceC.refreshSchema) === null || _this$options$sourceC2 === void 0 || _this$options$sourceC2.call(_this$options$sourceC);
  }
}
function initCustomStateSchemas() {
  var _this$options$sourceC3, _customStateSchema$fi2;
  const schema = (_this$options$sourceC3 = this.options.sourceConfig) === null || _this$options$sourceC3 === void 0 || (_this$options$sourceC3 = _this$options$sourceC3.fields) === null || _this$options$sourceC3 === void 0 ? void 0 : _this$options$sourceC3.find(item => item.id === 'customState');
  if (schema) {
    this.customStateSchema = schema;
    return;
  }
  const {
    cgiInfo
  } = this.collection.collectionData;
  const customStateSchema = {
    id: 'customState',
    title: '自定义接口返回的数据',
    type: 'object',
    fields: []
  };
  Object.entries(cgiInfo).forEach(([name, cgiInfo]) => {
    var _customStateSchema$fi;
    if (!name.startsWith(customApiPrefix)) {
      return;
    }
    let cgiResSchema = {
      id: name,
      title: `[${name}]接口的返回数据`,
      required: false
    };
    const schema = getRealResponseSchema(cgiInfo);
    if (schema) {
      cgiResSchema = Object.assign(cgiResSchema, cloneDeep(schema));
      cgiResSchema.id = name;
      cgiResSchema.title = `[${name}]接口的返回数据`;
    }
    (_customStateSchema$fi = customStateSchema.fields) === null || _customStateSchema$fi === void 0 || _customStateSchema$fi.push(cgiResSchema);
  });
  if (!((_customStateSchema$fi2 = customStateSchema.fields) !== null && _customStateSchema$fi2 !== void 0 && _customStateSchema$fi2.length)) {
    customStateSchema.hidden = true; // 没有数据就隐藏吧
  }
  this.customStateSchema = customStateSchema;
}
function init$RequestsSchema() {
  const {
    collection
  } = this;
  const {
    cgiInfo
  } = collection.collectionData;
  const cgis = this.getSupportedCgis();
  // $requests[api]的请求方法的schema ，设计模式使用
  const ms = cgis.filter(name => cgiInfo[name]).map(name => {
    const info = cgiInfo[name];
    const paramSchema = this.getCgiParamSchema(name);
    const returnSchema = this.getCgiResponseSchema(name);
    const schema = {
      id: name,
      title: info.desc || `调用接口[${name}]`,
      arguments: [paramSchema],
      returnValue: returnSchema,
      isAsync: true
    };
    return schema;
  });
  this.$requestsSchema = {
    id: '$requests',
    title: '数据源接口集合',
    type: 'object',
    hidden: true,
    methods: ms
  };
}
export function initRuntime$Requests() {
  const cgis = this.getSupportedCgis();
  // 初始化 $requests[api]的请求方法
  cgis.forEach(name => {
    this.$requests[name] = get$RequestFunction.call(this, name);
  });
  Object.freeze(this.$requests);
}
/**
 * 异步情况下需要使用 proxy进行代理等待数据源配置拉取
 */
export function initRuntime$RequestsProxy() {
  const target = {};
  const proxy = new Proxy(target, {
    get: (_, cgiName) => {
      if (target[cgiName]) {
        return target[cgiName];
      }
      return async (...args) => {
        await this.promiseForCollection;
        const supported = this.getCgiSupported(cgiName);
        if (!supported) {
          const {
            collectionId
          } = this.collection.collectionData;
          throw new Error(`数据源【${collectionId}】没有【${cgiName}】接口`);
        }
        const func = get$RequestFunction.call(this, cgiName);
        target[cgiName] = func;
        return func(...args);
      };
    }
  });
  hideProp(this, '$requests', {
    value: proxy
  });
  hideProp(this, '__$requestsProxyHost', {
    value: target
  });
}
function get$RequestFunction(name) {
  const {
    collection
  } = this;
  const {
    type
  } = collection.collectionData;
  const originFn = this.collection[name];
  const currentTemplate = this.collection.template.apiTemplates.find(t => t.name === name);
  const func = function (params, options = {}) {
    const requestOptions = {
      ...options,
      raw: true
    };
    // 检查接口是否有批量能力
    if (requestOptions.batchEnabled) {
      if (type === 'db' && currentTemplate && currentTemplate.canBeBatched) {
        return originFn.call(collection, params, requestOptions);
      }
      throw new Error(`wuji-source: 当前数据源接口${type}-${name}无法进行批量请求`);
    }
    return originFn.call(collection, params, requestOptions);
  };
  return func;
}
//# sourceMappingURL=BaseState.methods.js.map
